<template>
    <BaseModal @close="$emit('close')">
        <img :src="avatarUrl(user)" class="avatar_full_screen">
    </BaseModal>
</template>

<script>
import BaseModal from "@/UI/Modals/BaseModal.vue";

export default {
    name: "AvatarFullScreen",
    components: { BaseModal },
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    methods: {
        avatarUrl(user) {
            const userpic = user?.userpic;

            if (!userpic?.related) return fallbackAvatar;

            return import.meta.env.VITE_IMG_BASE_URL + userpic.related;
        }
    }
}
</script>

<style>
.avatar_full_screen {
    aspect-ratio: 1 / 1;
    border-radius: 20px;
    max-width: 95%;
    max-height: 95vh;
    width: auto;
    height: auto;
    object-fit: contain;
    margin: auto;
}
</style>